/*
 * @Author: Teemo Ding
 * @Date: 2021-06-25 10:45:59
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-02 11:46:10
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Invoice/AvailableInvoice/index.tsx
 */
import { Button, Checkbox, Radio } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { Form } from 'antd';
import React from 'react';
import css from '../css.module.less';
import { testInvoice } from 'src/request/order';
import { get } from 'lodash';
// /setting/store/invoice/test/{printingPageSize}"
// printingPageSize 'A4' or 'A5'.
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const AvailableInvoice = ({
  disabled,
  disableEdit,
  form,
}: {
  disabled?: boolean;
  form?;
  disableEdit?: boolean;
}) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const pageSize = [
    {
      label: `${getI18n('storeInvoice.detail.a4size')} (210 x 297mm)`,
      value: 'A4',
    },
    {
      label: `${getI18n('storeInvoice.detail.a5size')} (148 x 210mm)`,
      value: 'A5',
    },
  ];
  const [, setPreviewLoading] = React.useState(false);

  const dataView = [
    {
      checkTitle: getI18n('storeInvoice.detail.downloadDigital'),
      checkKey: 'downloadable',
      radioKey: 'downloadSize',
      btnText: getI18n('storeInvoice.detail.previewTestInvoice'),
      btnClick: () => {
        if (form) {
          const size = form.getFieldValue('downloadSize');
          const blob = testInvoice(size, false);

          if (blob) {
            setPreviewLoading(true);
            try {
              blob.then((res) => {
                const data = get(res, 'data');
                const url = window.URL.createObjectURL(
                  new Blob([data], { type: 'application/pdf' }),
                ); //获得一个pdf的url对象
                window.open(url, '_blank'); //打开一个新窗口
                URL.revokeObjectURL(url); //释放内存
                setPreviewLoading(false);
              });
            } catch (e) {
              console.error(e);
              setPreviewLoading(false);
            }
          }

          // console.log('')
          //   const win = window.open('https://www.baidu.com', '_blank');
          // win.focus();
        }
      },
    },
    {
      checkTitle: getI18n('storeInvoice.detail.printinvoice'),
      checkKey: 'printable',
      radioKey: 'printSize',
      btnText: getI18n('storeInvoice.detail.previewTestInvoice'),
      btnClick: () => {
        if (form) {
          const size = form.getFieldValue('printSize');
          try {
            testInvoice(size, true);
          } catch (e) {
            console.error(e);
          }

          // console.log('')
          //   const win = window.open('https://www.baidu.com', '_blank');
          // win.focus();
        }
      },
    },
  ];

  const renderItem = (
    key,
    { checkTitle, checkKey, radioKey, btnText, btnClick },
  ) => (
    <div className={css.itemContain} key={key}>
      <Form.Item noStyle name={checkKey} valuePropName='checked'>
        <Checkbox disabled={disableEdit}>{checkTitle}</Checkbox>
      </Form.Item>
      <Form.Item
        noStyle
        shouldUpdate={(prevValues, currentValues) =>
          prevValues[checkKey] !== currentValues[checkKey]
        }>
        {({ getFieldValue }) => {
          const disabled = !getFieldValue(checkKey) || disableEdit;
          return (
            <div>
              {getFieldValue(checkKey) ? (
                <Form.Item noStyle name={radioKey} initialValue={'A4'}>
                  <Radio
                    disabled={disableEdit}
                    className={css.radioContain}
                    radioList={pageSize}></Radio>
                </Form.Item>
              ) : null}
              {!disabled && (
                <Button
                  className={css.button}
                  onClick={btnClick}
                  disabled={disabled}>
                  {btnText}
                </Button>
              )}
            </div>
          );
        }}
      </Form.Item>
    </div>
  );

  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.container}
      title={getI18n('storeInvoice.detail.availableInvoice')}
      subtitle={getI18n('storeInvoice.detail.availableInvoiceTip')}>
      {disabled ? null : dataView.map((item, index) => renderItem(index, item))}
    </SectionWrapper>
  );
};
export default AvailableInvoice;
